<template>
    <span v-bind="$attrs"
        :aria-hidden="title ? null : true"
        :aria-label="title"
        class="material-design-icon bell-remove-outline-icon"
        role="img"
        @click="$emit('click', $event)">
        <svg :fill="fillColor"
            class="material-design-icon__svg"
            :width="size"
            :height="size"
            viewBox="0 0 24 24">
            <path d="M10,21H14A2,2 0 0,1 12,23A2,2 0 0,1 10,21M21,19V20H3V19L5,17V11C5,7.9 7.03,5.17 10,4.29C10,4.19 10,4.1 10,4A2,2 0 0,1 12,2A2,2 0 0,1 14,4C14,4.1 14,4.19 14,4.29C16.97,5.17 19,7.9 19,11V17L21,19M17,11A5,5 0 0,0 12,6A5,5 0 0,0 7,11V18H17V11M19.75,3.19L18.33,4.61C20.04,6.3 21,8.6 21,11H23C23,8.07 21.84,5.25 19.75,3.19M1,11H3C3,8.6 3.96,6.3 5.67,4.61L4.25,3.19C2.16,5.25 1,8.07 1,11Z">
                <title v-if="title">{{ title }}</title>
            </path>
        </svg>
        <Badge :value="value" v-if="value > 0" severity="danger"></Badge>
    </span>
</template>
  
<script>
  export default {
    name: "BellRemoveOutlineIcon",
    emits: ['click'],
    props: {
      title: {
        type: String,
      },
      fillColor: {
        type: String,
        default: "currentColor"
      },
      size: {
        type: Number,
        default: 18
      },
      value: {
        type: Number,
        default: 0
      }
    }
  }
</script>
<style>
.bell-remove-outline-icon {
    position: relative;
    padding: 0 4px;
}

.bell-remove-outline-icon .p-badge {
    font-size: 0.75rem;
    font-weight: 600;
    min-width: 1rem;
    height: 1rem;
    line-height: 1rem;
    position: absolute;
    top: -6px;
    right: -6px;
    padding: 0 4px !important;
    border-radius: 999px;
    background-color: red;
    color: white;
}


</style>